// alterado - revisado

import React from 'react'

import { FieldArray } from 'formik'

import LABEL from '../../../business-const/Label/Label'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    GridContainer,
    GridItem1,
    GridItem10,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import { 
    TextFieldTextSelect,
} from '../../../business-components/TextField/TextFieldSelect'

import {
    IconButtonClearEntradaDados
} from '../../../business-components/IconButton/IconButton'

import {
    ButtonIncluirLinha
} from '../../../business-components/Button/Button'

import {
    equipeListCompartilhamento,
} from './CompartilhamentoService'



const CompartilhamentoForm = ({ variaveisGlobais, values, handleChange, equipeList, perfil, jsonConfiguracao }) => {

    return (
        <FieldArray name="compartilhamentoUsuario">
            {(arrayHelpers) => (
                <DivForm>
                    <DivForm>
                        <GridContainer>
                            {values.compartilhamentoUsuario?.map((item, ind) => {

                                return (
                                    <GridItem12
                                        key={ind}
                                    >
                                        <GridContainer>
                                            <GridItem10>
                                                <TextFieldTextSelect
                                                    name={`compartilhamentoUsuario[${ind}].id`}
                                                    label={LABEL.usuario}
                                                    value={item.id || ''}
                                                    onChange={handleChange}
                                                    list={
                                                        equipeListCompartilhamento(variaveisGlobais, values, item.id, perfil,
                                                            jsonConfiguracao, equipeList)
                                                    }
                                                />
                                            </GridItem10>

                                            <GridItem1 />

                                            <GridItem1>
                                                <IconButtonClearEntradaDados
                                                    onClick={() =>
                                                        arrayHelpers.remove(ind)
                                                    }
                                                />
                                            </GridItem1>
                                        </GridContainer>
                                    </GridItem12>
                                )
                            })}
                        </GridContainer>
                    </DivForm>

                    <GridContainer>
                        <ButtonIncluirLinha
                            label={LABEL.buttonIncluirUsuario} 
                            onClick={() => 
                                arrayHelpers.push({})
                            }
                        />
                    </GridContainer>
                </DivForm>
            )}
        </FieldArray>
    )
}

export default CompartilhamentoForm